import { ERROR_ALERT, SUCCESS_ALERT } from "../../actions/commonAction";
import { axiosPostWithToken } from "../../services/apiServices";

export const createEditAction = ({ apiEndpoint, fetchAction, entityName }) => {
  return (data, handleClose, action_type) => {
    return async (dispatch, getState) => {
      const token = getState().auth.token;
      try {
        const res = await axiosPostWithToken(apiEndpoint, data, token);

        if (res.data.status_code === 200) {
          handleClose();
          dispatch(fetchAction());
          dispatch({
            type: SUCCESS_ALERT,
            payload: `${entityName} was ${action_type === 'accept' ? 'Updated' : 'rejected'} successfully!!`,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: (res.data.status_code === 400 && res?.data?.data?.message)
              || `Unable to Edit ${entityName}!! Please try again.`,
          });
        }
      } catch (error) {
        dispatch({
          type: ERROR_ALERT,
          payload: `Unable to Edit ${entityName}!! Please try again.`,
        });
      }
    };
  };
};